import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute } from '@angular/router';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { LayoutService } from 'app/layout/layout.service';
import { RelatedToType } from 'app/shared/enums';
import { capitalizeFirstLetter } from 'app/shared/Utils/common.utils';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CommonAction, TaskRole, TaskRolesResolverData, routeTypeMap } from '../task-roles.types';
import { Account } from 'app/core/models';
import { AccountService } from 'app/core';
import { TaskRolesAddComponent } from '../task-roles-add/task-roles-add.component';
import { Select, Store, Actions, ofActionSuccessful } from '@ngxs/store';
import { TaskRolesState } from '../state/state';
import { TaskRolesActions } from '../state/actions';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

type TaskRolesListParams = { type: RelatedToType };

@Component({
  selector: 'app-task-roles-list',
  templateUrl: './task-roles-list.component.html',
  styleUrls: ['./task-roles-list.component.scss'],
})
export class TaskRolesListComponent extends OnDestroyMixin implements OnInit {
  searchValue$: Observable<string>;
  type: RelatedToType;
  taskRoles: TaskRole[];
  relatedToTypes: RelatedToType[];
  displayedColumns = ['name', 'actions'];

  @Select(TaskRolesState.get) taskRoles$: Observable<TaskRole[]>;

  private get account(): Account {
    return this.accountService.getCurrentAccount();
  }

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly layoutService: LayoutService,
    private readonly dialogService: MatDialog,
    private readonly accountService: AccountService,
    private readonly store: Store,
    private readonly actions$: Actions,
    private readonly snackBar: MatSnackBar,
  ) {
    super();
  }

  ngOnInit(): void {
    this.activatedRoute.params
      .pipe(untilComponentDestroyed(this))
      .subscribe(({ type }: TaskRolesListParams) => (this.type = type));

    this.activatedRoute.parent.data
      .pipe(untilComponentDestroyed(this))
      .subscribe(({ taskRolesData }: { taskRolesData: TaskRolesResolverData }) => {
        this.relatedToTypes = taskRolesData.relatedToTypes;
      });

    this.actions$.pipe(ofActionSuccessful(TaskRolesActions.Delete), untilComponentDestroyed(this)).subscribe(() => {
      const error = this.store.selectSnapshot(TaskRolesState.getDeleteError);
      if (error) {
        this.snackBar.open(error, null, {
          duration: 3000,
          panelClass: 'error-snackbar',
        });
      }
    });

    this.taskRoles$.pipe(untilComponentDestroyed(this)).subscribe((taskRoles) => (this.taskRoles = taskRoles));

    this.searchValue$ = this.layoutService
      .getCommon<string>(CommonAction.roleSearch)
      .pipe(untilComponentDestroyed(this));

    this.layoutService
      .getCommon(CommonAction.addRole)
      .pipe(
        untilComponentDestroyed(this),
        filter((mode: string) => !!mode),
      )
      .subscribe((_) => {
        const relatedToType = routeTypeMap[this.type] ?? capitalizeFirstLetter(this.type);
        this.dialogService.open(TaskRolesAddComponent, {
          panelClass: 'mailbox-compose-dialog',
          data: { relatedToType },
        });
      });
  }

  deleteRole(taskRole: TaskRole) {
    this.store.dispatch(new TaskRolesActions.Delete(taskRole.id, +this.account.id));
  }
}
